import { s, typographyTokens } from '@/theme/tokens';
import { Box } from '@/ui/primitives';
import { InfoOutlinedIcon } from '@/ui/primitives/icons';
import type { ReactElement, ReactNode } from 'react';

type MetricCardTitleProps = {
  children: ReactNode;
  fontSize?: string | { xs?: number; xl?: number };
  showInfoIcon?: boolean;
};

export const MetricCardTitle = ({
  children,
  fontSize = typographyTokens.body.fontSize,
  showInfoIcon = false,
}: MetricCardTitleProps): ReactElement => (
  <Box
    sx={{
      minWidth: 0,
      display: 'flex',
      alignItems: 'center',
      gap: s('sm'),
      color: (theme) => theme.app.colors.textMuted,
      fontSize,
      fontWeight: typographyTokens.body.fontWeight,
      lineHeight: 1.25,
      whiteSpace: 'nowrap',
    }}
  >
    <Box component="span" sx={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>
      {children}
    </Box>
    {showInfoIcon ? (
      <InfoOutlinedIcon
        sx={{
          flexShrink: 0,
          fontSize: 17,
          color: 'inherit',
          transform: 'translateY(1px)',
        }}
      />
    ) : null}
  </Box>
);
